<script setup lang="ts">
import RichTextRenderer from 'contentful-rich-text-vue-renderer';
import contentfulHelper from "@/core/helpers/contentfulHelper";
import ApodisPremiumAdvantages from "@/subscription-plan/components/apodis-premium/ApodisPremiumAdvantages.vue";
import ApodisPremiumCheckoutButton from "@/subscription-plan/components/apodis-premium/ApodisPremiumCheckoutButton.vue";
import {Calculator} from "@lucide/vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import useHealthcenterAdvantages from "@/advantage/composables/useHealthcenterAdvantages";
import AdvantagesAnimatedButton from "@/advantage/components/AdvantagesAnimatedButton.vue";
import GroupingAdvantageButton from "@/advantage/components/GroupingAdvantageButton.vue";

defineProps<{
    salesPitch: any;
    salesPitchFooter?: string;
}>();

const {data} = useHealthcenterAdvantages();
</script>

<template>
  <div class="space-y-6">
    <div class="bg-white rounded-lg overflow-hidden space-y-8 shadow-[5px_5px_0_0_#65efca]">
      <div class="p-6 space-y-8">
        <div class="sales-pitch">
          <RichTextRenderer :document="salesPitch" :node-renderers="contentfulHelper.renderNodes()" />
        </div>
        <ApodisPremiumAdvantages :advantages="data ?? []" />
        <div class="flex items-center">
          <div class="flex-1">
            <h2 v-if="salesPitchFooter">
              {{ salesPitchFooter }}
            </h2>
          </div>
          <ApodisPremiumCheckoutButton horizontal />
        </div>
      </div>
      <div class="bg-gray-100 px-6 py-3 flex items-center justify-between">
        <p><strong>Découvrez votre potentiel</strong></p>
        <BaseButton class="text-primary" :to="{name: 'extensions-profitability'}">
          <Calculator class="h-full square mr-1 text-black" />
          Estimer mes revenus potentiels
        </BaseButton>
      </div>
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <label>Obtenez des réductions sur votre abonnement</label>
      <GroupingAdvantageButton :healthcenter-has-advantages="!!data?.length" />
      <AdvantagesAnimatedButton />
    </div>
  </div>
</template>

<style scoped>
:deep(.sales-pitch ul) {
    @apply !pl-0;
}

:deep(.sales-pitch li) {
    @apply flex items-start;
    list-style: none;
}

:deep(.sales-pitch li) {
    @apply mb-2 !important;
}

:deep(.sales-pitch li::before) {
    content: "✓";
    @apply text-secondary text-3xl top-2 relative;
    margin-right: 10px;
}
</style>
